import { useState, useEffect } from 'react';

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup
} from 'react-leaflet';

import 'leaflet/dist/leaflet.css';

import L from 'leaflet';

import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';


L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});


import {
  Card,
  CardContent,
  CardHeader,
  CardTitle
} from '@/components/ui/card';

import { Button } from '@/components/ui/button';

import {
  MapPin,
  Navigation,
  Users,
  RefreshCw,
  Truck
} from 'lucide-react';

import { api } from '@/lib/api';



interface DelegateLocation {

  delegateId:number;

  delegateName:string;

  delegatePhone:string;

  latitude:number;

  longitude:number;

  speed:number|null;

  heading:number|null;

  accuracy:number|null;

  address:string;

  timestamp:string;

  minutesAgo:number;

}



export default function GPSTrackingPage(){


const [locations,setLocations]
=
useState<DelegateLocation[]>([]);


const [loading,setLoading]
=
useState(false);


const [lastUpdate,setLastUpdate]
=
useState(new Date());


const [autoRefresh,setAutoRefresh]
=
useState(true);



const fetchLocations = async()=>{

try{

setLoading(true);


const response =
await api.get('/api/delegatelocations');

if(response.data.success){

const payload = response.data?.data ?? response.data;
      setLocations(Array.isArray(payload) ? payload : (payload?.items ?? []));

setLastUpdate(new Date());

}


}catch(error){

console.error(
'Error fetching locations:',
error
);

}

finally{

setLoading(false);

}

};




useEffect(()=>{

fetchLocations();

},[]);



useEffect(()=>{


let interval:number;


if(autoRefresh){

interval =
window.setInterval(
fetchLocations,
10000
);

}


return()=>{

if(interval){

clearInterval(interval);

}

};


},[autoRefresh]);





const activeDelegates =
locations.filter(
x=>x.minutesAgo < 5
).length;


const inactiveDelegates =
locations.length-activeDelegates;





return (

<div
className="space-y-6"
dir="rtl"
>


<div
className="
flex
flex-col
sm:flex-row
sm:justify-between
gap-4
"
>


<div>


<h1
className="
text-3xl
font-bold
flex
items-center
gap-3
"
>

<div
className="
w-12
h-12
bg-gradient-to-br
from-emerald-500
to-teal-600
rounded-xl
flex
items-center
justify-center
"
>

<Navigation
className="text-white"
/>

</div>


تتبع المندوبين المباشر


</h1>


<p className="text-gray-500 mt-2">

آخر تحديث:
{lastUpdate.toLocaleTimeString('ar-EG')}

</p>


</div>




<div className="flex gap-2">


<Button
onClick={()=>
setAutoRefresh(!autoRefresh)
}
>

<RefreshCw
className={
autoRefresh
?
"animate-spin ml-2"
:
"ml-2"
}
/>


{
autoRefresh
?
"التحديث التلقائي مفعل"
:
"التحديث التلقائي متوقف"
}


</Button>




<Button
onClick={fetchLocations}
disabled={loading}
>

<RefreshCw
className={
loading
?
"animate-spin ml-2"
:
"ml-2"
}
/>


تحديث


</Button>



</div>


</div>







<div
className="
grid
grid-cols-1
md:grid-cols-3
gap-4
"
>


<Card>

<CardHeader>

<CardTitle>
إجمالي المندوبين
</CardTitle>

</CardHeader>


<CardContent>

<div
className="text-3xl font-bold"
>

{locations.length}

</div>

</CardContent>

</Card>





<Card
className="bg-emerald-50 border-emerald-200"
>

<CardHeader>

<CardTitle>
نشط
</CardTitle>

</CardHeader>


<CardContent>

<div
className="text-3xl font-bold text-emerald-700"
>

{activeDelegates}

</div>

</CardContent>

</Card>





<Card
className="bg-red-50 border-red-200"
>

<CardHeader>

<CardTitle>
غير نشط
</CardTitle>

</CardHeader>


<CardContent>

<div
className="text-3xl font-bold text-red-700"
>

{inactiveDelegates}

</div>

</CardContent>

</Card>


</div>








<Card>

<CardHeader>

<CardTitle>
خريطة المندوبين
</CardTitle>

</CardHeader>

<CardContent>

{
locations.length===0

?

<div
className="
text-center
py-12
text-gray-500
"
>

<MapPin
className="
w-16
h-16
mx-auto
"
/>

لا يوجد مندوبين متصلين

</div>

:

<MapContainer
  center={[
    Number(locations[0]?.latitude) || 27.9158,
    Number(locations[0]?.longitude) || 34.33
  ]}
  zoom={12}
  style={{
    height:'500px',
    width:'100%'
  }}
>

<TileLayer
  url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
  attribution="&copy; OpenStreetMap contributors &copy; CARTO"
/>

{
locations.map(location=>(

<Marker
key={location.delegateId}
position={[
Number(location.latitude),
Number(location.longitude)
]}
>

<Popup>

<div dir="rtl">

<b>{location.delegateName}</b>

<br />

الهاتف:
{location.delegatePhone}

<br />

العنوان:
{location.address || '-'}

<br />

السرعة:
{location.speed ?? 0} كم/س

<br />

آخر تحديث:
منذ {Math.floor(location.minutesAgo)} دقيقة

</div>

</Popup>

</Marker>

))

}

</MapContainer>

}

</CardContent>

</Card>


<Card>

<CardHeader>

<CardTitle>
قائمة المندوبين
</CardTitle>

</CardHeader>


<CardContent>


<div
className="overflow-x-auto"
>

<table
className="w-full"
>


<thead
className="bg-gray-50"
>

<tr>

<th className="p-3">
المندوب
</th>

<th className="p-3">
الهاتف
</th>

<th className="p-3">
العنوان
</th>

<th className="p-3">
السرعة
</th>

<th className="p-3">
الحالة
</th>

</tr>

</thead>


<tbody>


{

locations.map(location=>(


<tr
key={location.delegateId}
className="border-b"
>


<td className="p-3">

{location.delegateName}

</td>


<td className="p-3">

{location.delegatePhone}

</td>


<td className="p-3">

{location.address || '-'}

</td>


<td className="p-3">

{
location.speed
?
`${location.speed} كم/س`
:
'-'
}

</td>


<td className="p-3">


<span
className={
location.minutesAgo < 5
?
"bg-green-100 text-green-700 px-2 py-1 rounded"
:
"bg-red-100 text-red-700 px-2 py-1 rounded"
}
>

{
location.minutesAgo < 5
?
"نشط"
:
"غير نشط"
}

</span>


</td>


</tr>


))


}


</tbody>


</table>


</div>


</CardContent>


</Card>



</div>

);


}
